import { render, staticRenderFns } from "./Comment.vue?vue&type=template&id=1a75617b&scoped=true"
import script from "./Comment.vue?vue&type=script&lang=js"
export * from "./Comment.vue?vue&type=script&lang=js"
import style0 from "./Comment.vue?vue&type=style&index=0&id=1a75617b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a75617b",
  null
  
)

export default component.exports